var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarcodeExample(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 56,
    viewBox: "0 0 206 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.34961 0H0V56H3.34961V0Z",
    fill: "#1F1F21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69949 0H5.02344V56H6.69949V0Z",
    fill: "#1F1F21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7229 0H10.0469V56H11.7229V0Z",
    fill: "#1F1F21"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0979 0H18.4219V56H20.0979V0Z",
    fill: "#1F1F21"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1191 0H21.7695V56H25.1191V0Z",
    fill: "#1F1F21"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8174 0H26.793V56H31.8174V0Z",
    fill: "#1F1F21"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5198 0H36.8438V56H38.5198V0Z",
    fill: "#1F1F21"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2422 0H43.543V56H50.2422V0Z",
    fill: "#1F1F21"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.594 0H51.918V56H53.594V0Z",
    fill: "#1F1F21"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9456 0H55.2695V56H56.9456V0Z",
    fill: "#1F1F21"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6426 0H60.293V56H63.6426V0Z",
    fill: "#1F1F21"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0159 0H70.3398V56H72.0159V0Z",
    fill: "#1F1F21"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M77.041 0H73.6914V56H77.041V0Z",
    fill: "#1F1F21"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4182 0H83.7422V56H85.4182V0Z",
    fill: "#1F1F21"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7698 0H87.0938V56H88.7698V0Z",
    fill: "#1F1F21"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4629 0H92.1133V56H95.4629V0Z",
    fill: "#1F1F21"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M100.49 0H97.1406V56H100.49V0Z",
    fill: "#1F1F21"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M107.186 0H103.836V56H107.186V0Z",
    fill: "#1F1F21"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M112.211 0H110.535V56H112.211V0Z",
    fill: "#1F1F21"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M117.236 0H113.887V56H117.236V0Z",
    fill: "#1F1F21"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M123.934 0H122.258V56H123.934V0Z",
    fill: "#1F1F21"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M130.633 0H128.957V56H130.633V0Z",
    fill: "#1F1F21"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M142.359 0H135.66V56H142.359V0Z",
    fill: "#1F1F21"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M145.711 0H144.035V56H145.711V0Z",
    fill: "#1F1F21"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M149.059 0H147.383V56H149.059V0Z",
    fill: "#1F1F21"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M154.08 0H150.73V56H154.08V0Z",
    fill: "#1F1F21"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M159.11 0H157.434V56H159.11V0Z",
    fill: "#1F1F21"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M167.481 0H165.805V56H167.481V0Z",
    fill: "#1F1F21"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M170.832 0H169.156V56H170.832V0Z",
    fill: "#1F1F21"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M182.551 0H175.852V56H182.551V0Z",
    fill: "#1F1F21"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M187.576 0H184.227V56H187.576V0Z",
    fill: "#1F1F21"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M197.626 0H192.602V56H197.626V0Z",
    fill: "#1F1F21"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M200.981 0H199.305V56H200.981V0Z",
    fill: "#1F1F21"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M205.998 0H202.648V56H205.998V0Z",
    fill: "#1F1F21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcodeExample);
export default __webpack_public_path__ + "static/media/Barcode_example.c9a148f15664fe4efe9e1f200feb7dc3.svg";
export { ForwardRef as ReactComponent };